import { loadImages } from "../utils/importImages";

const weddingImages = loadImages(
  require.context("./Images", false, /Wed\d+\.webp$/)
);

function Wedding() {
  return (
    <div id="scroll-container" className="scroll-container">
      <h2>Weddings</h2>
      {weddingImages.map((src, index) => (
        <img
          key={index}
          src={src}
          alt={`Wedding ${index + 1}`}
          loading="lazy"
        />
      ))}
    </div>
  );
}

export default Wedding;

